import { render, staticRenderFns } from "./Vorstoesse.vue?vue&type=template&id=b61ca49e"
import script from "./Vorstoesse.vue?vue&type=script&lang=js"
export * from "./Vorstoesse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports